import { Navigate } from 'react-router-dom';
import { requireModule } from '../../../auth/guards';
import { MODULES } from '../../../auth/permissions';
import { AdminLeavesSection, MyLeavesSection } from './sections';

/**
 * Leave, split by who uses it (V30): everyone applies and follows their own on My Leaves; the
 * approvers work the queue on Leave Approvals. The monthly register moved to HR → Attendance
 * Register (daily attendance, V28).
 */
export const attendanceRoutes = [
  {
    path: '/my-leaves',
    loader: requireModule(MODULES.LEAVES),
    handle: { breadcrumb: 'My Leaves' },
    element: <MyLeavesSection />,
  },
  {
    path: '/leave-approvals',
    loader: requireModule(MODULES.LEAVE_APPROVALS),
    handle: { breadcrumb: 'Leave Approvals' },
    element: <AdminLeavesSection />,
  },
  // The old combined page.
  { path: '/attendance', element: <Navigate to='/my-leaves' replace /> },
];
